import { dateFormatter } from "./helpers";

export default function initTableTooltip() {
  $('.table-list__item').uitooltip({
    track: true,
    classes: {
      'ui-tooltip': 'table-tooltip-box'
    },
    position: { my: "left+15 center", at: "right center" },
    content: function () {
      const graphValues = $(this).find('.table-bar').text().trim().split(',');
      const maxValue = Math.max(...graphValues);
      const maxValueIdx = graphValues.indexOf(maxValue.toString());
      const since = this.dataset.since;
      const period = $('#period').val();

      return (`
            <div class="tooltip-box">
              <p class="light tooltip-title">Malware info</p>
              <div class="tooltip-box__subfield">
                <p>Max daily tasks</p>
                <p class="light">${maxValue}</p>
              </div>
              <div class="tooltip-box__subfield">
                <p>Date</p>
                <p class="light">${dateFormatter(since, period, maxValueIdx)}</p>
              </div>
            </div>
            <div class="tooltip-box-bg"></div>`);
    }
  });
}